import type { ReactNode } from 'react'
import Link from 'src/components/Link'
import styles from './DiscoverLink.module.css'
export default function DiscoverLink({ href, children }: { href: string; children: ReactNode }) {
  return <Link href={href} className={styles.link}>{children}<svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' aria-hidden='true' focusable='false'><path d='M5 19 19 5M5 5h14v14' /></svg></Link>
}
